import _ from "underscore";
import axios from "axios";
import * as config from "../app.config";
import {
  formatAPI,
  wait,
  changeFormatForOther,
  formatGenomeOrganism,
  mapAppType,
  convertToCaseFormat,
} from "../util/format";
import { history } from "../store/configureStore";
// import nacl from "tweetnacl";
// import { encodeBase64 } from "tweetnacl-util/";
export const FETCH_ASSAY_DETAIL = "FETCH_ASSAY_DETAIL";
export const ADD_TO_USER_ASSAYS = "ADD_TO_USER_ASSAYS";
export const FETCH_ASSAYS = "FETCH_ASSAYS";
export const DISPLAY_MESSAGE = "DISPLAY_MESSAGE";
export const CLEAR_DISPLAY_MESSAGE = "CLEAR_DISPLAY_MESSAGE";
export const FETCHED_VALIDATED_ASSAYS = "FETCH_VALIDATED_ASSAYS";
export const FETCHED_ASSAY_RESULTS = "FETCHED_ASSAY_RESULTS";
export const REMOVE_VALIDATED_RESULT = "REMOVE_VALIDATED_RESULT";
export const SUBMITTED_VALUES = "SUBMITTED_VALUES";
export const LOADING_PAGE = "LOADING_PAGE";
export const ASSAY_ADDED_TO_LIST = "ASSAY_ADDED_TO_LIST";
export const REJECTED_COMMERCIAL_ID = "REJECTED_COMMERCIAL_ID";
export const CLEAR_COMMERCIAL_ID = "CLEAR_COMMERCIAL_ID";
export const CHANGE_MODAL_TYPE = "CHANGE_MODAL_TYPE";
export const SELECT_UUID_FOR_ASSAY = "SELECT_UUID_FOR_ASSAY";
export const CLEAR_UUID_FOR_ASSAY = "CLEAR_UUID_FOR_ASSAY";
export const UPDATE_EDIT_REGION = "UPDATE_EDIT_REGION";
export const SEARCH_RESULTS = "SEARCH_RESULTS";

//-------MODAL TYPE CONSTANTS------------
export const DELETE_ASSAY_MODAL = "DELETE_ASSAY_MODAL";
export const ADD_TO_CART_MODAL = "ADD_TO_CART_MODAL";

const MAIN_API = `${config.ENDPOINTS.main}/v1`;
//const MAIN_API = "https://cfu46rplyh.execute-api.us-west-2.amazonaws.com/dev/v1";

const ASSAY_API_ENDPOINTS = {
  design: "assay-design", //POST design engine or in gex dealing with result set should have complete/incomplete arrays
  history: "assay-design/history", //GET what populates the my assay page
  detail: "assay", //GET retrievs assay detail ${commercialized_id}
  remove: "assay-design", //DELETE removes assay from users my assay list => Needs to be changed
  view: "assay-design", // Mark the assay as viewed => Needs to be changed,
  validate: "assay-design/validation", // Validating the create assay payload.
  name: "assay-props", // To update assay name
  search: "assays/search",
};

// const sessionId = "9f4c7500033640aa8b5fa1dfc2894fd1";

axios.default.withCredentials = true;

//axios.defaults.headers.get['Pragma'] = 'no-cache';
//axios.defaults.headers.get['Cache-Control'] = 'no-cache, no-store';

axios.interceptors.request.use(
  (config) => {
    // Your Interceptor code to do something with the request data
    // Return config
    return config;
  },
  (error) => {
    // Your Interceptor code to do something with request error
    // Return error
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => {
    // Your Interceptor code to do something with the response data
    // Return response data
    return response;
  },
  (error) => {
    // Your Interceptor code to do something with response error
    // Return error
    return Promise.reject(error);
  }
);

const getGuid = () => {
  const s4 = () =>
    Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  return s4() + s4() + "-" + s4() + "-" + s4() + "-" + s4() + "-" + s4() + s4();
};

/* EDIT: make the func private.*/
function handleErrors(resp) {
  return (dispatch) => {
    const status = (resp && resp.response && resp.response.status) || 503;
    switch (status) {
      case 503:
        dispatch({
          type: DISPLAY_MESSAGE,
          displayType: "error",
          text: "Service currently not available.",
          key: getGuid(),
        });
        break;
      case 500:
        dispatch({
          type: DISPLAY_MESSAGE,
          displayType: "error",
          text: "Internal Server Error - 500",
          key: getGuid(),
        });
        break;
      case 422:
        dispatch({
          type: DISPLAY_MESSAGE,
          displayType: "error",
          text: "There are one or more errors ",
          key: getGuid(),
        });
        break;
      case 504:
        dispatch({
          type: DISPLAY_MESSAGE,
          displayType: "error",
          text: "Request timed out - Retry",
          key: getGuid(),
        });
        break;

      default:
        dispatch({
          type: DISPLAY_MESSAGE,
          displayType: "error",
          text: "Something wrong - try login again",
          key: getGuid(),
        });
        break;
    }
  };
}

export function displayMessage(message = "Hi", type = "success") {
  return (dispatch) => {
    return dispatch({
      type: DISPLAY_MESSAGE,
      displayType: type,
      text: message,
      key: getGuid(),
    });
  };
}

export function setAssayModalType(modalType, uniqueRowId) {
  const payload = {
    modalType: modalType || "",
    uniqueRowId: uniqueRowId || "",
  };

  return (dispatch) => {
    dispatch({ type: CHANGE_MODAL_TYPE, payload: payload });
  };
}

export function clearMessage() {
  return (dispatch) => {
    dispatch(clearDisplayMessage());
    dispatch(clearValidationMessages());
  };
}

export function clearDisplayMessage() {
  return (dispatch) => {
    dispatch({ type: CLEAR_DISPLAY_MESSAGE });
  };
}

function setUserId(user) {

  const output =
    (user &&
      user.digitalAssaysUser &&
      user.digitalAssaysUser.split("-").join("")) ||
    "";
  return output;
}

function setHeaders(userId) {
  const headers = {
    "Content-Type": "application/json",
    userId: userId,
  };
  return headers;
}

function _createMetaDetail(d) {
  let detailMeta = { title: "", description: "", keywords: "" };

  if (!d.id) {
    return detailMeta;
  }

  const assayName = d.orderingInfo.assayName ? d.orderingInfo.assayName : d.id;

  detailMeta.title = `${assayName}`;

  if (
    d.target &&
    d.target.genome &&
    d.target.genome.organism &&
    d.target.genome.organism !== "null"
  ) {
    detailMeta.title = `${detailMeta.title}, ${changeFormatForOther(
      formatGenomeOrganism(d.target.genome.organism)
    )}`;
  }

  detailMeta.description = `The ${assayName} ${mapAppType(
    d.applicationType
  )} Assay is a ${d.chemistry.toLowerCase()}`;

  if (d.chemistry === "EvaGreen") {
    detailMeta.description = `${detailMeta.description} dye based ddPCR primer set.`;
  } else {
    detailMeta.description = `${detailMeta.description} based ddPCR primer set with a ${d.dyes} fluorophore.`;
  }

  const validationType = d.validation.type === "WetLab" ? "has" : "has not";
  const re = /_/gi;
  const instrumentText =
    _.size(d.compatibleInstruments) > 1
      ? `${d.compatibleInstruments.join(" and ").replace(re, "")} instruments`
      : `${d.compatibleInstruments[0].replace(re, "")} instrument`;

  detailMeta.description = `${
    detailMeta.description
  } This ${assayName} ${mapAppType(
    d.applicationType
  )} Assay ${validationType} been wet lab validated. This assay is compatible with the ${instrumentText}.`;

  detailMeta.keywords = `${mapAppType(d.applicationType)}, ${assayName}, ${
    d.id
  }`;

  if (d.target && d.target.genome && d.target.genome.organism) {
    detailMeta.keywords = `${detailMeta.keywords}, ${d.target.genome.organism}`;
  }
  if (d.target && d.target.genome && d.target.genome.build) {
    detailMeta.keywords = `${detailMeta.keywords},${d.target.genome.build}`;
  }
  if (d.target && d.target && d.target.gene && d.target.gene.name) {
    detailMeta.keywords = `${detailMeta.keywords}, ${d.target.gene.name}`;
  }
  if (d.target && d.target && d.target.gene && d.target.gene.aliasSymbols) {
    detailMeta.keywords = `${
      detailMeta.keywords
    }, ${d.target.gene.aliasSymbols.join(", ")}`;
  }

  return detailMeta;
}

function queryAssayDetail(assayCommercialId) {
  return (dispatch, getState) => {
    const { user } = getState();
    const userId = setUserId(user);
    const headerConfig = setHeaders(userId);
    const ASSAY_DETAIL_API = formatAPI(MAIN_API, ASSAY_API_ENDPOINTS.detail);
    return axios
      .get(`${ASSAY_DETAIL_API}/${assayCommercialId.replace(/\s/g, "")}`, {
        headers: headerConfig,
      })
      .then((resp) => {
        const d = (resp && resp.data && resp.data.data) || {};
        const detailMeta = _createMetaDetail(d);
        dispatch({ type: FETCH_ASSAY_DETAIL, payload: resp, detailMeta });
      })
      .catch((err) => {
        if (
          err &&
          err.response &&
          (err.response.status === 404 || err.response.status === 403)
        ) {
          dispatch({
            type: REJECTED_COMMERCIAL_ID,
            payload: assayCommercialId,
          });
          dispatch({
            type: FETCH_ASSAY_DETAIL,
            payload: err,
          });
        } else {
          dispatch(handleErrors(err));
        }
      });
  };
}

// Fetch a single Assay Detail using the Assay ID - Using Data stub for now
export function fetchAssayDetail(assayCommercialId, assayDesignId) {
  const caseSensitiveCommercializedID = convertToCaseFormat(assayCommercialId);
  return (dispatch) => {
    Promise.resolve(dispatch(queryAssayDetail(caseSensitiveCommercializedID)))
      .then((res) => {
        if (res && assayDesignId) {
          dispatch(assayViewed(assayDesignId));
        }
      })
      .catch((err) => {
        dispatch(handleErrors(err));
      });
  };
}

export function fetchAssaySearchResult(searchString) {
  const SEARCH_ENDPOINT = formatAPI(MAIN_API, ASSAY_API_ENDPOINTS.search);

  return (dispatch, getState) => {
    const { user } = getState();

    const userId = setUserId(user);
    const headerConfig = setHeaders(userId);
    dispatch({
      type: LOADING_PAGE,
      payload: { pageLoading: true },
    });
    return axios
      .get(`${SEARCH_ENDPOINT}?q=${searchString}`, {
        headers: headerConfig,
      })
      .then((res) => {
        dispatch({ type: SEARCH_RESULTS, payload: res });
        dispatch({
          type: LOADING_PAGE,
          payload: { pageLoading: false },
        });
      });
  };
}

export function fetchUserAssays() {
  return (dispatch, getState) => {
    const { user } = getState();
    const userId = setUserId(user);
    const headerConfig = setHeaders(userId);
    const FETCH_USER_ASSAYS = formatAPI(MAIN_API, ASSAY_API_ENDPOINTS.history);
    dispatch({
      type: LOADING_PAGE,
      payload: { pageLoading: true },
    });
    wait(500); // 500 ms wait.
    return axios
      .get(FETCH_USER_ASSAYS, {
        headers: headerConfig,
      })
      .then((resp) => {
        dispatch({
          type: LOADING_PAGE,
          payload: { pageLoading: false },
        });
        dispatch({ type: FETCH_ASSAYS, payload: resp });
      })
      .catch((err) => {
        dispatch({
          type: LOADING_PAGE,
          payload: { pageLoading: false },
        });
        dispatch(handleErrors(err));
      });
  };
}

export function removeUserAssay(assayUniqueId) {
  return (dispatch, getState) => {
    const { user } = getState();
    const userId = setUserId(user);
    const headerConfig = setHeaders(userId);
    const DELETE_ASSAY_ENDPOINT = formatAPI(
      MAIN_API,
      ASSAY_API_ENDPOINTS.remove
    );

    dispatch({
      type: LOADING_PAGE,
      payload: { pageLoading: true },
    });

    // axios Delete has an issue in the IE. Reverting to old ways.
    return axios
      .delete(`${DELETE_ASSAY_ENDPOINT}/${assayUniqueId}`, {
        headers: headerConfig,
      })
      .then(() => {
        //wait(500);
        dispatch(fetchUserAssays());

        dispatch({
          type: LOADING_PAGE,
          payload: { pageLoading: false },
        });
      })
      .catch((err) => {
        dispatch({
          type: LOADING_PAGE,
          payload: { pageLoading: false },
        });
        dispatch(handleErrors(err));
      });
  };
}

function processAddRequest(assayCommercialId) {
  const output = {};
  output.assayId = assayCommercialId.trim("");
  return output;
}

export function addToMyAssay(assayCommercialId, redirectUrl = "") {
  return (dispatch, getState) => {
    const { user } = getState();
    const userId = setUserId(user);
    const headerConfig = setHeaders(userId);
    const payload = processAddRequest(assayCommercialId);

    const ADD_TO_MY_LIST_API = formatAPI(MAIN_API, ASSAY_API_ENDPOINTS.history);

    return axios
      .post(ADD_TO_MY_LIST_API, payload, {
        headers: headerConfig,
      })
      .then((resp) => {
        dispatch({
          type: DISPLAY_MESSAGE,
          displayType: "success",
          text: "Assay has been added successfully",
          key: getGuid(),
        });
        dispatch({ type: ASSAY_ADDED_TO_LIST, payload: resp });

        if (redirectUrl.length) {
          history.push(`/digital-assays/${redirectUrl}`);
        } else {
          resp && dispatch(fetchAssayDetail(assayCommercialId));
        }
      })
      .catch((err) => {
        err &&
          dispatch({
            type: DISPLAY_MESSAGE,
            displayType: "error",
            text: "One or More Assay Id's are Invalid",
            key: getGuid(),
          });
      });
  };
}

export function batchAddToMyAssays(assayCommercialIdList) {
  return (dispatch, getState) => {
    const validateApiList = _.clone(assayCommercialIdList)
      .map(queryAssayDetail)
      .map(dispatch);
    dispatch({
      type: LOADING_PAGE,
      payload: { pageLoading: true },
    });
    return Promise.all(validateApiList).then((resp) => {
      const {
        assays: { rejectedCommercializedId },
      } = getState();
      !_.isEmpty(rejectedCommercializedId) &&
        dispatch({
          type: LOADING_PAGE,
          payload: { pageLoading: false },
        });

      if (resp && _.isEmpty(rejectedCommercializedId)) {
        const apiList = _.clone(assayCommercialIdList)
          .map(addToMyAssay)
          .map(dispatch);
        return Promise.all(apiList).then((resp) => {
          resp && history.push("/digital-assays/assay-design-history");
          dispatch({
            type: LOADING_PAGE,
            payload: { pageLoading: false },
          });
          dispatch({
            type: DISPLAY_MESSAGE,
            displayType: "success",
            text: "All the assay IDs are processed.",
            key: getGuid(),
          });
        });
      }
    });
  };
}

export function assayViewed(assayUniqueId) {
  return (dispatch, getState) => {
    const { user } = getState();
    const userId = setUserId(user);
    const headerConfig = setHeaders(userId);
    const ASSAY_VIEWED_API = formatAPI(MAIN_API, ASSAY_API_ENDPOINTS.view);
    return (
      axios
        .patch(
          `${ASSAY_VIEWED_API}/${assayUniqueId}`,
          { viewed: "yes" },
          {
            headers: headerConfig,
          }
        )
        // Removing the then because we don't need to deal with response
        .catch((err) => {
          dispatch(handleErrors(err));
        })
    );
  };
}

function _processDyes(dyes) {
  if (_.isEmpty(dyes) || !dyes) {
    return ["FAM", "HEX"];
  }
  if (dyes.includes("/")) {
    return dyes.split("/");
  }
  return [dyes];
}

function _processGenome(genome) {
  let organism = "";
  switch (genome) {
    case "Other":
      organism = "";
      break;
    case "Homo sapiens":
    case "Mus musculus":
    case "Rattus norvegicus":
      organism = genome;
      break;
    default:
      organism = "Homo sapiens";
  }
  return organism;
}
function _processbuild(genome) {
  let build = "";
  switch (genome) {
    case "Other":
      build = "Other";
      break;
    case "Homo sapiens":
      build = "hg19";
      break;
    case "Mus musculus":
      build = "mm10";
      break;

    case "Rattus norvegicus":
      build = "rn5";
      break;
    default:
      build = "hg19";
  }
  return build;
}
function _generatepayload(applicationType, item, userId) {
  return {
    applicationType: applicationType,
    userId: userId,
    assayFormat: item.assayFormat || "SingleTube",
    dyes: _processDyes(item.fluorophores) || "",
  };
}

function formatInputPayload(frmValues, userId, editRegionDonorRange) {
  let payload = [];
  const {
    applicationType,
    mutationDetectionForm,
    cellAndGeneTherapyForm,
    copyNumberDeterminationForm,
  } = frmValues;
  var payloadChunk = {};

  switch (applicationType) {
    
    case "MutationDetection":
      
      mutationDetectionForm.map((mutationDetectionValue) => {
        const targetby = frmValues.targetby;
        if (targetby === "identifier") {
          const item = mutationDetectionValue.mutationdetectionidentifier;
          payloadChunk = _generatepayload(applicationType, item, userId);
          payloadChunk.name = item.identifier;
          payloadChunk = {
            ...payloadChunk,
            targetSpecifier: {
              type: item.assayType,
              uuid: item.uuid || undefined,
              identifier: item.identifier || "",
            },
          };
          payload.push(payloadChunk);
        } else {
          const item = mutationDetectionValue.mutationdetectionsequence;
          payloadChunk = _generatepayload(applicationType, item, userId);
          payloadChunk.name = item.assayTargetName;
          payloadChunk = {
            ...payloadChunk,
            targetSpecifier: {
              type: item.assayType,
              sequence: item.sequence || "",
              genome: {
                organism: _processGenome(item.genome),
                build: _processbuild(item.genome),
              },
            },
          };
          payload.push(payloadChunk);
        }
      });
      break;
    case "CopyNumberDetermination":
      copyNumberDeterminationForm.map((copyNumberDeterminationValue, index) => {
        const targetby = frmValues.targetby;
        
        //const { targetby } = copyNumberDeterminationValue;
        if (targetby === "identifier") {
          const item =
            copyNumberDeterminationValue.copynumberdeterminationidentifier;
          payloadChunk = _generatepayload(applicationType, item, userId);
          payloadChunk.name = item.identifier;
          payloadChunk = {
            ...payloadChunk,
            targetSpecifier: {
              identifier: item.identifier || "",
              uuid: item.uuid || undefined,
              genome: {
                build: _processbuild(item.genome),
              },
            },
          };
          payload.push(payloadChunk);
        } else {
          const item =
            copyNumberDeterminationValue.copynumberdeterminationsequence;
          payloadChunk = _generatepayload(applicationType, item, userId);
          payloadChunk.name = item.assayTargetName;
          payloadChunk = {
            ...payloadChunk,
            targetSpecifier: {
              sequence: item.sequence || "",
              genome: {
                build: _processbuild(item.genome),
              },
            },
          };
          payload.push(payloadChunk);
        }
      });
      break;
    case "GeneExpression":
      if (frmValues.targetBy === "identifier") {
        frmValues.geneExpressionIdentifier &&
          frmValues.geneExpressionIdentifier.map((item) => {
            payload.push({
              applicationType: applicationType,
              name: item.identifier,
              userId: userId, //Needs to be changed.
              dyes: _processDyes(item.fluorophores) || "",
              assayFormat: item.assayFormat || "SingleTube",
              targetSpecifier: {
                type: item.assayType || "Gene",
                identifier: item.identifier || "",
                uuid: item.uuid || undefined,
                genome: {
                  organism: _processGenome(item.genome),
                  build: _processbuild(item.genome),
                },
              },
            });
          });
      }
      break;

    case "GenomeEditDetection":
      var { targetBy } = frmValues;
      if (targetBy === "NhejGenomeEdit") {
        const item =
          frmValues &&
          frmValues.genomeEditDetectionNhej &&
          frmValues.genomeEditDetectionNhej[0];
        payload.push({
          applicationType: applicationType,
          name: item.assayTargetName,
          userId: userId, // Needs to be changed.
          dyes: _processDyes(item.fluorophores) || "",
          assayFormat: item.assayFormat || "SingleTube",
          contextSequenceRelation: item.contextSequenceRelation,
          donorPresent: item.donorPresent === "true",
          matchReferenceGenome: item.sequenceVariationType === "true",
          targetSpecifier: {
            type: item.assayType,
            contextSequence: item.contextSequence,
            donorSequence: item.donorSequence || undefined,
            contextSequenceRelationToGenome:
              item.contextSequenceRelation || undefined, // undefined.
            genome: {
              organism: _processGenome(item.species),
              build: _processbuild(item.species),
            },
          },
        });
      } else {
        const item =
          frmValues &&
          frmValues.genomeEditDetectionHDR &&
          frmValues.genomeEditDetectionHDR[0];
        payload.push({
          applicationType: applicationType,
          name: item.assayTargetName,
          contextSequenceRelation: item.sequenceVariationType === "false" && item.contextSequenceRelation || "ExactMatch", // Need to verify the payload in prod has `ExactMatch`
          userId: userId, //Needs to be changed.
          dyes: _processDyes(item.fluorophores) || "",
          editRegionConfirmed: item.editRegionConfirmed || false, // need to write logic, if true, will skip the confirm page.
          matchReferenceGenome: item.sequenceVariationType === "true",
          assayFormat: item.assayFormat || "SingleTube",
          targetSpecifier: {
            type: item.assayType,
            contextSequenceRelationToGenome:
            item.sequenceVariationType === "false" && item.contextSequenceRelation || "ExactMatch",
            contextSequence: item.contextSequence,
            sequence: null, // Need to validate if context sequence
            donorSequence: item.donorSequence || undefined,
            editRegionDonorRange:
              (!_.isEmpty(editRegionDonorRange) && editRegionDonorRange) ||
              undefined, // Need to change the logic
            genome: {
              organism: _processGenome(item.species),
              build: _processbuild(item.species),
            },
          },
        });
      }
      break;

    case "GeneTherapy":
      cellAndGeneTherapyForm.map((GeneTherapyValue) => {
        const item = GeneTherapyValue.cellandgenetherapysequence;
        payloadChunk = _generatepayload(applicationType, item, userId);
        payloadChunk.name = item.assayTargetName;
        payloadChunk.universalAssay = frmValues.universalAssay;
        payloadChunk = {
          ...payloadChunk,
          targetSpecifier: {
            type: "DnaSequence",
            sequence: item.sequence || "",
          },
        };
        payload.push(payloadChunk);
      });
      break;
  }
  return payload;
}

function frmAssayPaylod(values, userId, editRegionDonorRange) {
  //var frmValues = getFrmValues(values);
  const findAssays = formatInputPayload(values, userId, editRegionDonorRange);
  return findAssays;
}

export function processGetNewAssays(values) {
  return (dispatch, getState) => {
    const { user } = getState();
    const userId = setUserId(user);
    const findAssays = frmAssayPaylod(values, userId);
    const { applicationType } = values || "";

    if (
      applicationType === "GeneTherapy" &&
      _.isEmpty(findAssays) &&
      values.universalAssay !== "null"
    ) {
      //console.info("case 1 only universalAssay");
      return dispatch(
        addToMyAssay(values.universalAssay, "assay-design-history")
      );
    } else if (
      applicationType === "GeneTherapy" &&
      !_.isEmpty(findAssays) &&
      values.universalAssay === "null"
    ) {
      //console.info("case 2 only GOI");
      var myAssays = findAssays.map((assay) => {
        assay.universalAssay = null;
        return assay;
      });
      return dispatch(getNewAssays(myAssays));
    } else if (
      applicationType === "GeneTherapy" &&
      !_.isEmpty(findAssays) &&
      values.universalAssay !== "null"
    ) {
      //console.info("case 3 both GOI and Universal Assay");
      return dispatch(getNewAssays(findAssays))
        .then(
          (resp) =>
            resp &&
            dispatch(
              addToMyAssay(values.universalAssay, "assay-design-history")
            )
        )
        .catch((err) => handleErrors(err));
    } else {
      return dispatch(getNewAssays(findAssays));
    }
  };
}

export const getNewAssays = (findAssays, editRegionConfirmed) => {
  return (dispatch, getState) => {
    const { user } = getState();
    const DESIGN_ENGINE_API = formatAPI(MAIN_API, ASSAY_API_ENDPOINTS.design);
    const userId = setUserId(user);
    const headerConfig = setHeaders(userId);
    dispatch({
      type: SUBMITTED_VALUES,
      payload: findAssays,
    });

    dispatch({ type: LOADING_PAGE, payload: { pageLoading: true } });
    return new Promise((resolve, reject) => {
      axios
        .post(DESIGN_ENGINE_API, findAssays, {
          // post create request.
          headers: headerConfig,
        })
        .then((resp) => {
          //console.log(resp, "resp")
          dispatch({
            type: LOADING_PAGE,
            payload: { pageLoading: false },
          });
          dispatch({
            type: FETCHED_ASSAY_RESULTS,
            payload: resp,
          });
          /* Include logic GED confirmation page*/
          if (editRegionConfirmed === true) {
            history.push("/digital-assays/hdr-reference-assay");
          } else {
            history.push("/digital-assays/assay-design-history");
          }

          resolve(resp);
        })
        .catch((err) => {
          if (err && err.response && err.response.status === 422) {
            const {
              response: { data },
            } = err;
            // dispatch the loading bar.
            dispatch({
              type: LOADING_PAGE,
              payload: { pageLoading: false },
            });
            /*Takes care of the validation*/
            dispatch({
              type: FETCHED_VALIDATED_ASSAYS,
              payload: data,
            });
            if (
              findAssays[0].applicationType === "GenomeEditDetection" &&
              findAssays[0].targetSpecifier.type === "HdrGenomeEdit" &&
              !_.isEmpty(data.data[0].Targets)
            ) {
              history.push("/digital-assays/genome-confirmation");
            } else {
              reject(err);
            }
          } else {
            return dispatch(handleErrors(err));
          }
        });
    });
  };
};

export function setAssayName(values) {
  return (dispatch, getState) => {
    const UPDATE_ASSAY_NAME = formatAPI(MAIN_API, ASSAY_API_ENDPOINTS.name);
    const { user } = getState();
    const userId = setUserId(user);
    const headerConfig = setHeaders(userId);
    const { assayName, assayCommercialId, uniqueUuidId } = values;
    const payload = { assayName: assayName };
    return axios
      .post(`${UPDATE_ASSAY_NAME}/${values.assayCommercialId}`, payload, {
        headers: headerConfig,
      })
      .then(() => {
        dispatch(fetchAssayDetail(assayCommercialId, uniqueUuidId));
      });
  };
}

export function clearValidationMessages(index) {
  if (index) {
    return (dispatch) => {
      dispatch({
        type: REMOVE_VALIDATED_RESULT,
        payload: { index: index },
      });
    };
  }

  return (dispatch) => {
    dispatch({
      type: REMOVE_VALIDATED_RESULT,
    });
  };
}

export function clearValidatedCommercialIdList() {
  return (dispatch) => dispatch({ type: CLEAR_COMMERCIAL_ID });
}

export function clearAssayDetail() {
  return (dispatch) =>
    dispatch({ type: FETCH_ASSAY_DETAIL, payload: {}, detailMeta: {} });
}
